import type { FC } from 'react';
import * as Styled from './styled';
import type { ModalFooterProps } from './types';

export const ModalFooter: FC<ModalFooterProps> = (props) => {
  const { tag, text } = props;

  return (
    <Styled.Wrapper>
      <Styled.Badge>{tag}</Styled.Badge>
      <Styled.Text dangerouslySetInnerHTML={{ __html: text }} />
    </Styled.Wrapper>
  );
};
